import React from "react";
import ReactTooltip from 'react-tooltip';
import moment from "moment";

export default class AlteredLineDetailNote extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const lineDetail = this.props.vm;
        let body = null;
        let self = this;
        return (
            <div>
                <i className="fa fa-icon fa-pencil ap-color-red" data-tip data-for={`${lineDetail.timecardDetailLineId}_{altered}`} data-scroll-hide={false}
                    ref="alteredIcon" onClick={() => {
                        if (self.showingTooltip) {
                            ReactTooltip.hide(this.refs.alteredIcon);
                            self.showingTooltip = false;
                        } else {
                            ReactTooltip.show(this.refs.alteredIcon);
                            self.showingTooltip = true;
                        }
                    }} />                
                <ReactTooltip id={`${lineDetail.timecardDetailLineId}_{altered}`} effect='solid' place='bottom' scrollHide={false} className="ap-no-side-padding" >
                    <div className="container-fluid ap-small-font hidden-xs hidden-sm">
                        <div className="row ap-no-padding ap-no-margin">
                            <div className="col-md-6 col-lg-6 ap-no-padding ap-no-margin">
                                <div className="container-fluid ap-no-padding ap-no-margin">
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">

                                        </div>
                                        <div className="col-md-3">
                                            Date
                                        </div>
                                        <div className="col-md-3">
                                            In
                                        </div>
                                        <div className="col-md-4">
                                            Reason
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">

                                        </div>
                                        <div className="col-md-3 ap-unwrap-content ap-color-yellow">
                                            {moment(lineDetail.clockIn).format("M-D-YYYY")}
                                        </div>
                                        <div className="col-md-3 ap-unwrap-content ap-color-yellow">
                                            {moment(lineDetail.clockIn).format("h:mm A")}
                                        </div>
                                        <div className="col-md-4 ap-unwrap-content">
                                            {lineDetail.inReason}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">
                                            Actual:
                                        </div>
                                        <div className="col-md-3 ap-unwrap-content ap-color-yellow">
                                            {moment(lineDetail.systemClockIn).format("M-D-YYYY")}
                                        </div>
                                        <div className="col-md-3 ap-unwrap-content ap-color-yellow">
                                            {moment(lineDetail.systemClockIn).format("h:mm A")}
                                        </div>
                                        <div className="col-md-4 ap-unwrap-content">
                                            {lineDetail.inReason}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 col-lg-6 ap-no-padding ap-no-margin">
                                <div className="container-fluid ap-no-padding ap-no-margin">
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">

                                        </div>
                                        <div className="col-md-3">
                                            Date
                                        </div>
                                        <div className="col-md-3">
                                            Out
                                        </div>
                                        <div className="col-md-4">
                                            Reason
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">

                                        </div>
                                        <div className={lineDetail.clockOut ? "col-md-3 ap-unwrap-content ap-color-yellow" : "col-md-3 ap-unwrap-content ap-invisible"}>
                                            {moment(lineDetail.clockOut).format("M-D-YYYY")}
                                        </div>
                                        <div className={lineDetail.clockOut ? "col-md-3 ap-unwrap-content ap-color-yellow" : "col-md-3 ap-unwrap-content ap-invisible"}>
                                            {moment(lineDetail.clockOut).format("h:mm A")}
                                        </div>
                                        <div className="col-md-4 ap-unwrap-content">
                                            {lineDetail.outReason}
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="row ap-no-padding ap-no-margin">
                                        <div className="col-md-2">
                                            Actual:
                                        </div>
                                        <div className={lineDetail.systemClockOut ? "col-md-3 ap-unwrap-content ap-color-yellow" : "col-md-3 ap-unwrap-content ap-invisible"}>
                                            {moment(lineDetail.systemClockOut).format("M-D-YYYY")}
                                        </div>
                                        <div className={lineDetail.systemClockOut ? "col-md-3 ap-unwrap-content ap-color-yellow" : "col-md-3 ap-unwrap-content ap-invisible"}>
                                            {moment(lineDetail.systemClockOut).format("h:mm A")}
                                        </div>
                                        <div className="col-md-4 ap-unwrap-content">
                                            {lineDetail.outReason}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container-fluid ap-small-font hidden-md hidden-lg">
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Date In:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {moment(lineDetail.clockIn).format("M-D-YYYY")} &nbsp;
                                {moment(lineDetail.clockIn).format("h:mm A")}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Actual:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {moment(lineDetail.systemClockIn).format("M-D-YYYY")} &nbsp;
                                {moment(lineDetail.systemClockIn).format("h:mm A")}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Reason:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {lineDetail.inReason}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Date Out:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {moment(lineDetail.clockOut).format("M-D-YYYY")} &nbsp;
                                {moment(lineDetail.clockOut).format("h:mm A")}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Actual:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {moment(lineDetail.systemClockOut).format("M-D-YYYY")} &nbsp;
                                {moment(lineDetail.systemClockOut).format("h:mm A")}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-4 ap-unwrap-content">
                                Reason:
                            </div>
                            <div className="col-xs-8 col-sm-8 ap-unwrap-content ap-color-yellow">
                                {lineDetail.outReason}
                            </div>
                        </div>
                    </div>
                </ReactTooltip>
            </div>
        );
    }
}